export const ROTAS_COM_PERMISSAO = [
  // Laboratório
  { pathPrefix: "/precosExames", requiredPermissions: "TPE001" },
  { pathPrefix: "/agendaPaternidade", requiredPermissions: "AGP001" },
  { pathPrefix: "/espermograma", requiredPermissions: "ESP001" },
  { pathPrefix: "/respiratorio", requiredPermissions: "RES001" },
  
  // Administrativo
  { pathPrefix: "/CadastraCategoria", requiredPermissions: "AL003" },
  { pathPrefix: "/controleAcesso", requiredPermissions: "CA001" },
  { pathPrefix: "/notificacoesCovid", requiredPermissions: "SUS001" },
  { pathPrefix: "/almoxarifado/produtos/CadastraProduto", requiredPermissions: ["AL004", "AL005"] },
  { pathPrefix: "/almoxarifado/estoque/adicionar", requiredPermissions: ["AL009", "AL010"] },
  { pathPrefix: "/almoxarifado/estoque/visualizar", requiredPermissions: "AL008" },
  { pathPrefix: "/almoxarifado/transferencia/criar", requiredPermissions: ["AL012", "AL013"] },
  { pathPrefix: "/almoxarifado/transferencia/editar", requiredPermissions: "AL013" },
  { pathPrefix: "/almoxarifado/produtos", requiredPermissions: "AL002" },
  { pathPrefix: "/almoxarifado", requiredPermissions: "AL014" },
  { pathPrefix: "/inventario/bem/cadastrarBem", requiredPermissions: ["INV019", "INV020"] },
  { pathPrefix: "/inventario/bem/criaTransferencia", requiredPermissions: ["INV023", "INV024"] },
  { pathPrefix: "/inventario/editaInventario", requiredPermissions: "INV004" },
  { pathPrefix: "/inventario/criaInventario", requiredPermissions: "INV003" },
  { pathPrefix: "/inventario/inventarioBem", requiredPermissions: "INV026" },
  { pathPrefix: "/inventario", requiredPermissions: "INV001" },
  { pathPrefix: "/conexaoDNA", requiredPermissions: "CON001" },
  { pathPrefix: "/CadastraUsuario", requiredPermissions: "CU001" },
  { pathPrefix: "/faturamento", requiredPermissions: "FAT001" },
  { pathPrefix: "/centralDeBIs", requiredPermissions: "CTB001" },
  { pathPrefix: "/gestaoDeClientes/cadastroDeClientes", requiredPermissions: "GDC002" },
  { pathPrefix: "/gestaoDeClientes/editarCliente", requiredPermissions: "GDC003" },
  { pathPrefix: "/gestaoDeClientes", requiredPermissions: "GDC001" },
  { pathPrefix: "/atualizacoesApp", requiredPermissions: "AAP001" },
  { pathPrefix: "/mapaCurvas", requiredPermissions: "MC001" },
  { pathPrefix: "/mapaTrace", requiredPermissions: "MTR001" },
  { pathPrefix: "/mensagensApp", requiredPermissions: "MAP001" },
  { pathPrefix: "/amostras", requiredPermissions: "PCR001" },
  { pathPrefix: "/financeiro/contratos/criar", requiredPermissions: ["GEC006", "GEC007"] },
  { pathPrefix: "/financeiro/contratos", requiredPermissions: "FIN001" },
  { pathPrefix: "/financeiro/fornecedor/criar", requiredPermissions: ["GEC002", "GEC003"] },
  { pathPrefix: "/financeiro/fornecedor", requiredPermissions: "FIN001" },
  { pathPrefix: "/atendimentoAoCliente/formularioOuvidoria", requiredPermissions: ["ATC006", "ATC007"] },
  { pathPrefix: "/portalMedico", requiredPermissions: "PM001" },
];
